import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const money = (n) =>
  `A$${Number(n).toLocaleString("en-AU", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;

export function Reveal({ children, delay = 0, y = 32, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionTag({ children }) {
  return (
    <div className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-[#39FF14] flex items-center gap-3">
      <span className="h-px w-8 bg-[#39FF14]/60" />
      {children}
    </div>
  );
}
